(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-pdf"] && !Shopify.designMode) return;
  try {
    (function () {
      function handleize(v) {
        return (v || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      }

      function currentFitHandle(trigger) {
        var fitName = trigger.getAttribute('data-fit-option');
        if (!fitName) return null;
        var form = trigger.closest('.js-product') || document;
        var checked = form.querySelector('[data-option="' + fitName + '"] .opt-btn:checked, [data-option="' + fitName + '"] [aria-selected="true"]');
        if (checked) {
          var val = checked.value || checked.getAttribute('data-value') || (checked.querySelector('.js-value') && checked.querySelector('.js-value').textContent);
          return handleize(val);
        }
        return null;
      }

      function pickPdf(trigger) {
        var map = {};
        try { map = JSON.parse(trigger.getAttribute('data-pdfs') || '{}'); } catch (e) { map = {}; }
        var fit = currentFitHandle(trigger);
        if (fit && map[fit]) return map[fit];
        return map['default'] || null;
      }

      function openDialog(trigger) {
        var dialog = document.getElementById(trigger.getAttribute('data-target'));
        if (!dialog) return;
        var chartId = trigger.getAttribute('data-chart-id');
        var ext = dialog.querySelector('.js-size-guide-external');
        if (chartId && window.NoserSizeChart && window.NoserSizeChartData) {
          dialog.classList.add('size-guide-dialog--chart');
          if (ext) ext.style.display = 'none';
          var mount = dialog.querySelector('.js-size-chart-mount');
          if (mount && !mount.dataset.rendered) {
            var imgMap = {};
            var imgEl = document.querySelector('[data-size-chart-imgs]');
            if (imgEl) { try { imgMap = JSON.parse(imgEl.textContent); } catch (e) {} }
            window.NoserSizeChart.render(mount, chartId, imgMap, document.documentElement.lang && document.documentElement.lang.indexOf('en') === 0 ? 'en' : 'de');
            mount.dataset.rendered = '1';
          }
          if (typeof dialog.showModal === 'function') dialog.showModal();
          return;
        }
        var url = pickPdf(trigger);
        if (!url) return;
        var frame = dialog.querySelector('.js-size-guide-frame');
        if (frame) frame.src = url;
        if (ext) ext.href = url;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          window.open(url, '_blank');
        }
      }

      document.addEventListener('click', function (evt) {
        var opener = evt.target.closest('.js-size-guide-open');
        if (opener) {
          evt.preventDefault();
          openDialog(opener);
          return;
        }
        var closer = evt.target.closest('.js-size-guide-close');
        if (closer) {
          var d = closer.closest('.size-guide-dialog');
          if (d) d.close();
          return;
        }
      });

      document.addEventListener('click', function (evt) {
        var dialog = evt.target;
        if (dialog.classList && dialog.classList.contains('size-guide-dialog') && evt.target === dialog) {
          var rect = dialog.getBoundingClientRect();
          var inside = evt.clientX >= rect.left && evt.clientX <= rect.right && evt.clientY >= rect.top && evt.clientY <= rect.bottom;
          if (!inside) dialog.close();
        }
      });

      document.addEventListener('close', function (evt) {
        var d = evt.target;
        if (d.classList && d.classList.contains('size-guide-dialog')) {
          var frame = d.querySelector('.js-size-guide-frame');
          if (frame) frame.removeAttribute('src');
        }
      }, true);
    })();
  } catch(e) { console.error(e); }
})();

})();
